import { ColumnsType } from 'antd/es/table';
import {
  menteeObjectiveProps,
  MyObjectiveActions,
  USER_ROLES,
} from '../../../types';
import dayjs from 'dayjs';
import { Button, Popover, Tooltip } from 'antd';
import {
  EditFilled,
  DeleteFilled,
  CheckOutlined,
  InfoCircleFilled,
} from '@ant-design/icons';
import { useState } from 'react';
import { AuditTrail, Status } from '../../../components';
import { Statuses } from '../../../helper';
import { FieldTimeOutlined } from '@ant-design/icons';

export const menteeObjectivescolumns = (
  handleClick?: (
    data: menteeObjectiveProps,
    action: MyObjectiveActions
  ) => void,
  role?: string
): ColumnsType => [
  {
    title: 'Objective Category',
    dataIndex: 'objectiveCategory',
    key: 'objectiveCategory',
    sorter: (a: menteeObjectiveProps, b: menteeObjectiveProps) => {
      return a.objectiveCategory
        ?.trim()
        .localeCompare(b.objectiveCategory?.trim());
    },
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    sorter: (a: menteeObjectiveProps, b: menteeObjectiveProps) => {
      return a.description?.trim().localeCompare(b.description?.trim());
    },
  },
  {
    title: 'Expected Outcome',
    dataIndex: 'expectedOutcome',
    key: 'expectedOutcome',
    sorter: (a: menteeObjectiveProps, b: menteeObjectiveProps) => {
      return a.expectedOutcome?.trim().localeCompare(b.expectedOutcome?.trim());
    },
    width: 240,
    render: (text) => (
      <Tooltip title={text} overlayClassName="text-[12px]">
        {`${text.substring(0, 23)} ${text.length > 23 ? '...' : ''}`}
      </Tooltip>
    ),
  },
  {
    title: 'Set Date',
    dataIndex: 'startDate',
    key: 'startDate',
    sorter: (a: menteeObjectiveProps, b: menteeObjectiveProps) =>
      dayjs(a.startDate).diff(dayjs(b.startDate)),
    render: (date, { status }) => (
      <div>
        {status !== Statuses.Draft ? dayjs(date).format('MMM DD YYYY') : '-'}
      </div>
    ),
  },
  {
    title: 'Target Completion Date',
    dataIndex: 'endDate',
    key: 'endDate',
    sorter: (a: menteeObjectiveProps, b: menteeObjectiveProps) =>
      dayjs(a.endDate).diff(dayjs(b.endDate)),
    render: (date) => <div>{dayjs(date).format('MMM DD YYYY')}</div>,
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    sorter: (a: menteeObjectiveProps, b: menteeObjectiveProps) =>
      a.status?.trim().localeCompare(b.status?.trim()),
    render: (status) => <Status status={status} />,
  },
  {
    title: 'Action',
    key: 'Action',
    render: (data: menteeObjectiveProps) => {
      return (
        <div className="flex gap-x-[10px]">
          {data?.status !== Statuses.Draft ? <ViewAudit data={data} /> : null}
          {role === USER_ROLES.MENTOR ? (
            <>
              {data?.status === Statuses.Draft ? (
                <ActiveObjective
                  onClick={() => handleClick?.(data, 'active')}
                />
              ) : null}

              <Tooltip title="Edit Objective">
                <Button
                  icon={<EditFilled />}
                  onClick={() => handleClick?.(data, 'edit')}
                />
              </Tooltip>
              {data?.status === Statuses.Draft ? (
                <Tooltip title="Delete Objective">
                  <Button
                    icon={<DeleteFilled />}
                    onClick={() => handleClick?.(data, 'delete')}
                  />
                </Tooltip>
              ) : null}
            </>
          ) : role === USER_ROLES.MENTEE ? (
            <>
              <Tooltip title="Edit Objective">
                <Button
                  icon={<EditFilled />}
                  onClick={() => handleClick?.(data, 'edit')}
                />
              </Tooltip>
              {data?.status === Statuses.Draft && (
                <Tooltip title="Delete Objective">
                  <Button
                    icon={<DeleteFilled />}
                    onClick={() => handleClick?.(data, 'delete')}
                  />
                </Tooltip>
              )}
            </>
          ) : null}
        </div>
      );
    },
  },
];

//const { data }: { data: menteeObjectiveProps }
const ViewAudit = ({ data }: { data: menteeObjectiveProps }) => {
  const [open, setOpen] = useState(false);
  const hanldeClick = () => setOpen(true);
  return (
    <Tooltip title="View History" placement="left">
      <Button icon={<FieldTimeOutlined />} onClick={hanldeClick} />
      <AuditTrail setOpen={setOpen} open={open} id={data.id} />
    </Tooltip>
  );
};

const ActiveObjective = ({ onClick }: { onClick(): void }) => {
  const [open, setOpen] = useState(false);

  const handleOpenChange = (newOpen: boolean) => setOpen(newOpen);
  const hide = () => setOpen(false);

  const content = () => (
    <div className="p-[4px]">
      <div className="flex w-[230px] gap-x-[10px] items-center">
        <div>
          <InfoCircleFilled className="text-[16px] text-[#FAAD14]" />
        </div>
        <div>
          Are you sure you want to proceed? (After activation, this objective
          cannot be deleted and only certain fields will be editable)
        </div>
      </div>
      <div className="flex justify-end mt-4">
        <div className="flex gap-x-[10px]">
          <Button size="small" onClick={hide}>
            No
          </Button>
          <Button type="primary" size="small" onClick={onClick}>
            Yes
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <Tooltip title="Activate Objective">
      <Popover
        placement="left"
        content={content}
        trigger="click"
        onOpenChange={handleOpenChange}
        open={open}
      >
        <Button icon={<CheckOutlined />} />
      </Popover>
    </Tooltip>
  );
};
